import corso_hero from "../Images/home/core_stack/home_core_stack_architects.webp";
import collection_hero from "../Images/home/core_stack/home_core_stack_interior_designers.webp";
import development_hero from "../Images/home/core_stack/home_core_stack_developers.webp";
import capital_hero_a from "../Images/home/core_stack/home_core_stack_capital_market_leaders.webp";
import capital_hero_b from "../Images/home/core_stack/home_core_stack_asset_owners.webp";
import management_hero_a from "../Images/home/core_stack/home_core_stack_community_operators.webp";
import management_hero_b from "../Images/home/core_stack/home_core_stack_ehr_developers.webp";
import marketing_hero from "../Images/home/core_stack/home_core_stack_marketing.webp";

// Static copy for the Home page's "core stack" slider — the disciplines
// Galerie keeps in-house across its vertically-integrated structure. No
// links; edit title/body/image directly to adjust the story. Most images
// are still reused from the closest-matching company page as placeholders
// (no dedicated photo shot yet) — swap in real ones as they're shot, as
// already done for interior-designers/full-stack-marketers above.
export const core_stack = [
  {
    id: "architects",
    title: "Architects",
    body: "We design every community from the ground up, crafting spaces built around dignity, movement, and connection.",
    image: corso_hero,
  },
  {
    id: "interior-designers",
    title: "Interior Designers",
    body: "Warm materials, thoughtful light, and hospitality-grade finishes turn a floor plan into a place residents are proud to call home.",
    image: collection_hero,
  },
  {
    id: "developers",
    title: "Developers",
    body: "From site selection to groundbreaking, we develop every Galerie community ourselves - accountable to the neighborhoods we build in.",
    image: development_hero,
  },
  {
    id: "capital-market-leaders",
    title: "Capital Market Leaders",
    body: "Galerie Capital structures the financing behind every project, pairing disciplined underwriting with a long-term ownership mindset.",
    image: capital_hero_a,
  },
  {
    id: "ehr-developers",
    title: "EHR Developers",
    body: "Our in-house technology team builds the electronic health record and care-coordination tools our own communities run on.",
    image: management_hero_b,
  },
  {
    id: "community-operators",
    title: "Community Operators",
    body: "Galerie Management runs day-to-day life in every community, upholidng the Galerie standard of excellence through every moment of resdient life.",
    image: management_hero_a,
  },
  {
    id: "full-stack-marketers",
    title: "Full-Stack Marketers",
    body: "We tell every community's story ourselves, from brand and design to the digital campaigns that fill each residence.",
    image: marketing_hero,
  },
  {
    id: "asset-owners",
    title: "Asset Owners",
    body: "We hold what we build. As long-term owners, our incentives stay aligned with residents and families.",
    image: capital_hero_b,
  },
];
